import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";

/**
 * Функционал для инициализации плагина photoswipe https://photoswipe.com/
 */
class ProductGallery {
  #lightBox;

  constructor() {
    this.#initLightBox();
  }

  #initLightBox() {
    this.#lightBox = new PhotoSwipeLightbox({
      gallery: "#product-gallery",
      children: "a",
      showHideAnimationType: "none",
      pswpModule: PhotoSwipe,
    });

    this.#lightBox.init();
  }
}

export {ProductGallery};
